'use client'

import styles from './MenuItem.module.css'
import { Link } from '@/i18n/navigation'
import { MenuDataItem } from "../MenuData";
import { useTranslations } from "next-intl";
import { usePathname } from 'next/navigation';
import { forwardRef, useMemo } from 'react';
import { useWindowSize } from '@/hooks/useWindowsSize';
import { BREAKPOINTS } from '@/utils/constants';
import { pushToDataLayer, removeLocaleFromPath } from '@/utils/helpers';
import { useUserStore } from '@/stores/useUserStore';

type MenuDataItemProps = {
	item: MenuDataItem;
}

const MenuItem = forwardRef<HTMLDivElement, MenuDataItemProps>(({ item }, ref) => {
	const t = useTranslations('Menu')
	const { width } = useWindowSize()
	const { userId, profileId } = useUserStore()
	const rawPath = usePathname()
	const pathname = useMemo (
		() => removeLocaleFromPath(rawPath),
		[rawPath]
	)
	const MenuItemIcon = item.icon
	const selected = pathname.replace("/", "") === item.url.replace("/", "")

	function handleClick() {
		pushToDataLayer({
			event: 'home_menu_click',
			menu_item: item.title,
			page_name: pathname,
			user_state: userId && profileId ? 'loggedIn' : 'loggedOut'
		})
	}

	return (
		<div className={`${styles.main} ${selected ? styles.selected : ''}`} ref={ref} data-testid={`menu_item_${item.title}`}>
			{selected && <div className={styles.selectedBackground} />}
			<div className={styles.selectHover}></div>
			<Link href={item.url} className={`${styles.link} mediumButton`} onClick={handleClick}>
				<MenuItemIcon className={styles.icon} />
				{width >= BREAKPOINTS.TABLET ? t(item.title, { siteName: process.env.NEXT_PUBLIC_SITENAME as string }) : null}
			</Link>
		</div>
	)
})

MenuItem.displayName = "MenuItem"
export default MenuItem